interface StorageData {
  data: any;
  timestamp: number;
  expiration: number;
}

export const saveToStorage = (key: string, data: any, expirationMs: number = 24 * 60 * 60 * 1000): void => {
  try {
    const storageData: StorageData = {
      data,
      timestamp: Date.now(),
      expiration: expirationMs
    };
    localStorage.setItem(key, JSON.stringify(storageData));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

export const getFromStorage = (key: string): any | null => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;

    const storageData: StorageData = JSON.parse(item);
    const now = Date.now();
    
    if (now - storageData.timestamp > storageData.expiration) {
      localStorage.removeItem(key);
      return null;
    }

    return storageData.data;
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    return null;
  }
};

export const removeFromStorage = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Error removing from localStorage:', error);
  }
};

export const hasValidStorageData = (key: string): boolean => {
  return getFromStorage(key) !== null;
};

export const STORAGE_KEYS = {
  USER_DATA: 'darb_user_data',
  AUTH_TOKENS: 'darb_auth_tokens',
  AUTH_STATE: 'darb_auth_state'
} as const;

export const saveUserData = (userData: any): void => {
  saveToStorage(STORAGE_KEYS.USER_DATA, userData);
};

export const getUserData = (): any | null => {
  return getFromStorage(STORAGE_KEYS.USER_DATA);
};

export const saveAuthTokens = (tokens: { accessToken: string; refreshToken: string }): void => {
  saveToStorage(STORAGE_KEYS.AUTH_TOKENS, tokens);
};

export const getAuthTokens = (): { accessToken: string; refreshToken: string } | null => {
  return getFromStorage(STORAGE_KEYS.AUTH_TOKENS);
};

export const saveAuthState = (authState: { isLoggedIn: boolean }): void => {
  saveToStorage(STORAGE_KEYS.AUTH_STATE, authState);
};

export const getAuthState = (): { isLoggedIn: boolean } | null => {
  return getFromStorage(STORAGE_KEYS.AUTH_STATE);
};

export const clearAllAuthData = (): void => {
  removeFromStorage(STORAGE_KEYS.USER_DATA);
  removeFromStorage(STORAGE_KEYS.AUTH_TOKENS);
  removeFromStorage(STORAGE_KEYS.AUTH_STATE);
}; 